import React from 'react'

import ReserveDateTime from "components/SearchComponents/ReserveDateTime";
import Offers from "components/SearchComponents/Offers";
import {SameLocal} from "components/SearchComponents/SameLocal";
import SearchLocation from "components/SearchComponents/SearchLocation";

import {useApp} from "contexts/AppContext";
import {changeDropOffAction, changePickupAction, changeOfferCarAction} from "contexts/reducers/cars/actions";

export function FormSearchCars() {

    const { carState, carDispatch } = useApp()
    const { offersCar, locationPickupCar, locationDropOffCar, returnSameLocalCar } = carState


    const handlePickup = (data) => {
        carDispatch(changePickupAction(data))
    }

    const handleDropOff = (data) => {
        carDispatch(changeDropOffAction(data))
    }

    const changeOffers = (offers) => {
        carDispatch(changeOfferCarAction(offers))
    }

    return (
        <div className="box-search">
            <SearchLocation
                placeholder="Local de Retirada"
                onChange={handlePickup}
                location={locationPickupCar}
            />

            <SameLocal />

            <SearchLocation
                placeholder="Local de Entrega"
                disabled={returnSameLocalCar}
                onChange={handleDropOff}
                location={returnSameLocalCar ? locationPickupCar : locationDropOffCar}
            />

            <ReserveDateTime
                label="Selecione as datas de Check-in e Check-out"
            />

            <Offers
                offers={offersCar}
                changeOffers={changeOffers}
            />
        </div>
    )
}
